// extracted by mini-css-extract-plugin
export default {"selector":"CompanySelector_selector__6Tpxo","select":"CompanySelector_select__YVdJI"};